import React from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { Alert, Button, Modal } from '@printdeal/ui-library';
import { Message } from '../../../../../../types/Message';

interface ChangeShippingAddressFeedbackModalProps {
  feedbackStatus: 'error' | 'warning' | 'success';
  handleCloseModal: (eventName: string) => void;
}

const feedbackMessages: { [key:string]: Message } = defineMessages({
  shippingAddress_change_error: {
    id: 'account.order.shippingAddress.changeRequest.feedback.failed',
    defaultMessage: 'One or more of your line items could not be changed.',
  },
  shippingAddress_change_warning: {
    id: 'account.order.shippingAddress.changeRequest.feedback.pending',
    defaultMessage: 'We have received your request to change your shipping address. The change is still pending for one or more line items.',
  },
  shippingAddress_change_success: {
    id: 'account.order.shippingAddress.changeRequest.feedback.success',
    defaultMessage: 'The shipping address was updated successfully.',
  },
});

const ChangeShippingAddressFeedbackModal = ({
  feedbackStatus,
  handleCloseModal,
}: ChangeShippingAddressFeedbackModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen
      onClose={() => handleCloseModal('close_modal_chance_shipping_address_feedback_generic')}
      dismissLabel={intl.formatMessage({
        id: 'account.general.modal.close',
        defaultMessage: 'Close',
      })}
      title={intl.formatMessage({
        id: 'account.order.shippingAddress.changeRequest.feedback.title',
        defaultMessage: 'Change shipping address',
      })}
    >
      <Modal.Content>
        <Alert variant={feedbackStatus}>
          <FormattedMessage {...feedbackMessages[`shippingAddress_change_${feedbackStatus}`]} />
        </Alert>
      </Modal.Content>
      <Modal.Footer className="pd-text-right">
        <Button
          variant="primary"
          onClick={() => handleCloseModal('close_modal_chance_shipping_address_feedback_by_button')}
        >
          <FormattedMessage id="account.general.modal.close" defaultMessage="Close" />
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangeShippingAddressFeedbackModal;
